// extracted by css-extract-rspack-plugin
export default {"banner":"TxgM2E6UNUNy6gIQ"};